import { UserType } from '../../usersApp/types';

export interface UserBehaviorRisksAppWebComponentSchema {
  // all the data needed for rendering
  data: any;
  externalFilters: Array<any>;
}

export enum ColumnIndexes {
  COMPANY = 0,
  USER_BEHAVIOR_RISK = 1,
  RISK_SCORE = 2,
  AFFECTED_USERS = 3,
  OS = 4,
  MITIGATION = 5,
  STATUS = 6,
  STATE = 7,
  COMPLIANCE = 8,
  WATCHLIST = 9,
  SELECT = 10,
  REGIONS = 11,
}

export enum ColumnKeys {
  COMPANY = 'companyId',
  USER_BEHAVIOR_RISK = 'indicatorId',
  RISK_SCORE = 'scoreBreakdown.finalScore',
  OS = 'operatingSystem',
  AFFECTED_USERS = 'affectedUsers',
  MITIGATION = 'mitigation',
  STATUS = 'status',
  STATE = 'state',
  COMPLIANCE = 'compliance',
  WATCHLIST = 'watchlist',
  SELECT = 'select',
  REGIONS = 'regions',
}

export const USERS_TYPES_ORDER = [
  UserType.LOCAL,
  UserType.AD,
  UserType.ACTIVE_DIRECTORY_USER,
  UserType.IAM_ROLE,
  UserType.IAM_USER,
  UserType.IAM_USER_GROUP_ROLE,
  UserType.IAM_GROUP,
  UserType.ROOT_USER,
  UserType.IAM_SERVICE_ACCOUNT,
];

export const USERS_ICON_CLASS_MAP = new Map<UserType, string>([
  [UserType.LOCAL, 'ds-icon-local_user'],
  [UserType.AD, 'ds-icon-entity_user_AD'],
  [UserType.ACTIVE_DIRECTORY_USER, 'ds-icon-cloud_AD_user'],
  [UserType.IAM_USER, 'ds-icon-cloud_IAM_user'],
  [UserType.ROOT_USER, 'ds-icon-cloud_root_user'],
  [UserType.IAM_SERVICE_ACCOUNT, 'ds-icon-cloud_IAM_service_account'],
]);
